import dietActions from './actions';
import storeResourceFactory from '../../libs/storeResourceFactory';

const dietsStore = storeResourceFactory('diets', {});

const state = {
  ...dietsStore.state,
};

const actions = {
  initializeDiets: dietsStore.request(dietActions.initializeDiets),
};

const mutations = {
  ...dietsStore.mutations,
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./store/modules/diets/index.js